<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { computed, type PropType } from 'vue'

import CheckBoxField from '@/components/common/CheckBoxField.vue'

import { useApplicationStore } from '@/stores/application'
import { useValidationStore } from '@/stores/validation'
import { useAuthenticationStore } from '@/stores/authentication'

import type { ShipType } from '@/stores/type/ship.type'
import type { ValidationType } from '@/stores/type/validation.type'

const props = defineProps({
	ship: { type: Object as PropType<ShipType>, required: true }
})

const validationStore = useValidationStore()

const { items: apps } = storeToRefs(useApplicationStore())
const { user } = storeToRefs(useAuthenticationStore())

const validationItems = computed<ValidationType[]>(() => {
	return [...(props.ship?.validation_set ?? [])].sort((a, b) => a.id - b.id)
})

const disabled = computed<boolean>(() => {
	return !user.value?.is_superuser
})

function applicationName(applicationId: number): string {
	return apps.value.find((app) => app.id === applicationId)?.name ?? ''
}

function updateValidation(value: boolean, validation: ValidationType) {
	validation.approved = value
	validationStore.update(validation)
}

const emit = defineEmits<{ (e: 'click'): void }>()
</script>

<template>
	<v-menu :close-on-content-click="false">
		<template v-slot:activator="{ props }">
			<v-btn icon="mdi-list-status" v-bind="props" variant="text" @click="emit('click')"> </v-btn>
		</template>
		<v-card width="auto">
			<v-list density="compact">
				<v-list-item v-for="validation in validationItems" :key="validation.id" class="pl-2 py-0">
					<v-list-item-title>
						<CheckBoxField
							:disabled="disabled"
							:item="validation"
							:label="applicationName(validation.application)"
							parameter="approved"
							@set="(value) => updateValidation(value, validation)"
						/>
					</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-card>
	</v-menu>
</template>

<style scoped>
:deep(.v-input__control) {
	font-size: 14px !important;
}
:deep(.v-label) {
	font-size: 14px !important;
	opacity: 1;
}
</style>
